export const RoutePaths = {
  Empty: "/",
  Login: "/login",
  NotFound: "/not-found",
  Reports: "/reports",
  ReportCharts: "/reports/charts",
  ReportAnalytics: "/reports/analytics",
  Jackpots: "/jackpots",
  ForgotPassword: "/forgot-password",
  NewPassword: "/new-password/login",
  NewPasswordAuth: "/new-password",
  GameControl: "/game-control",
  ResetPassword: "/reset-password/login",
  Dashboard: "/dashboard",
  BusinessSettings: "/business-settings",
  Businesses: "/businesses",
  BetHistory: "/bet-history",
  Partners: "/partners",
  Betshops: "/betshops",
  Managers: "/managers",
  Cashiers: "/cashiers",
  Configurations: "/configurations",
  Transactions: "/transaction-history",
  Integration: "/integration",
  WildCard: "/*",
};
